<div class="position-relative p-3">
  <i class="position-absolute close bi bi-x-lg" [mat-dialog-close]=""></i>
  <div class="text-center my-5">
    <img src="assets/images/ic-check.svg" alt="" />
    <h4 class="mt-4" [innerHTML]="data.title"></h4>
  </div>
</div>
